import styled from 'styled-components'

const CallToActionStyle = styled.div`
	--sectionPadding: var(--sp23x) var(--sp56x);
	--descriptionMargin: var(--sp7x) 0 var(--sp8x) 0;
	--waveHeight: 68%;
	--waveWidth: 100%;
	--titleMaxWidth: var(--sp152x);
	--descriptionMaxWidth: var(--sp156x);

	.wave-svg {
		height: 0;
	}

	.content {
		display: flex;
		flex-direction: column;
		align-items: center;
		position: relative;
		padding: var(--sectionPadding);
		border-radius: var(--sp3x);
		overflow: hidden;

		.wave {
			position: absolute;
			bottom: 0;
			left: 0;
			opacity: 0.3;
			z-index: 0;
			width: var(--waveWidth);
			height: var(--waveHeight);
			background-color: var(--primaryColor1);
			-webkit-clip-path: url(${(props) => `#${props.clipPathId}`});
			clip-path: url(${(props) => `#${props.clipPathId}`});
		}

		.title {
			text-align: center;
			z-index: 1;
            max-width: var(--titleMaxWidth);
		}

		.description {
			margin: var(--descriptionMargin);
			max-width: var(--descriptionMaxWidth);
			text-align: center;
			z-index: 1;
		}

		.call-to-action-button {
			z-index: 1;
		}
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) =>
        theme.mediaQuery.DesktopSizeXLMin}) {
		--sectionPadding: var(--sp17x) var(--sp40x);
		--descriptionMargin: var(--sp5x) 0 var(--sp7x) 0;
		--waveHeight: 71%;
		--titleMaxWidth: var(--sp121x);
		--descriptionMaxWidth: var(--sp116x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) =>
        theme.mediaQuery.DesktopSizeLMin}) {
		--sectionPadding: var(--sp14x) var(--sp30x);
		--descriptionMargin: var(--sp4x) 0 var(--sp6x) 0;
		--waveHeight: 73%;
		--titleMaxWidth: var(--sp91x);
		--descriptionMaxWidth: var(--sp97x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) =>
        theme.mediaQuery.DesktopSizeMMin}) {
		--sectionPadding: var(--sp14x) var(--sp26x);
		--descriptionMargin: var(--sp4x) 0 var(--sp6x) 0;
		--waveHeight: 71%;
		--titleMaxWidth: var(--sp91x);
		--descriptionMaxWidth: var(--sp97x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) =>
        theme.mediaQuery.DesktopSizeSMin}) {
		--sectionPadding: var(--sp12x) var(--sp18x);
		--descriptionMargin: var(--sp4x) 0 var(--sp5x) 0;
		--waveHeight: 70%;
		--titleMaxWidth: var(--sp76x);
		--descriptionMaxWidth: var(--sp97x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) =>
        theme.mediaQuery.DesktopSizeXSMin}) {
		--sectionPadding: var(--sp10x) var(--sp13x);
		--descriptionMargin: var(--sp3x) 0 var(--sp5x) 0;
		--waveHeight: 65%;
		--titleMaxWidth: var(--sp61x);
		--descriptionMaxWidth: var(--sp97x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) =>
        theme.mediaQuery.TabletSizeMin}) {
		--sectionPadding: var(--sp10x) var(--sp8x);
		--descriptionMargin: var(--sp3x) 0 var(--sp5x) 0;
		--waveHeight: 67%;
		--titleMaxWidth: var(--sp61x);
		--descriptionMaxWidth: var(--sp65x);
	}

	@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--sectionPadding: var(--sp10x) var(--sp4x);
		--descriptionMargin: var(--sp3x) 0 var(--sp5x) 0;
		--waveHeight: 90%;
		--waveWidth: 150%;
		--titleMaxWidth: 100%;
		--descriptionMaxWidth: 100%;
	}
`

export default CallToActionStyle
